import { createAsyncStateWithPreloadHook } from '@lib/hooks';

import { GetJiraStatusResponse, integrationsActions } from '@sonar-software/sonar-integrations';

const empty: Array<GetJiraStatusResponse> = [];

/**
 * Subscribes to and returns the collection of jira Statuses. Will load related data upon mount if data is not
 * available or forced via `refresh`.
 * @param refresh Determines if the component should force load the latest data upon mount. Defaults to `false`.
 * @returns Array of {@link GetJiraStatusResponse}.
 */
export const useJiraStatuses = createAsyncStateWithPreloadHook({
	loadAction: integrationsActions.requestGetJiraStatuses,
	selector: (state) => state.integrations.jira.statuses.get,
	useTransform: (result) => result.data || empty
});
